export enum ContributorType {
  Any = 'any',
  Contributor = 'contributor',
  Owner = 'owner',
  Viewer = 'viewer',
}
